export const PARTNER_FEE_MAX_BPS = 100 // 1%
